<ng-container *appLet="{
  culture: culture$ | async,
} as $comp">
  @if ($comp.culture) {
    <div class="modal-header">
      <button
        id="btnClose"
        type="button"
        class="btn-close close"
        aria-label="Close"
        (click)="onCloseClick()"
      >
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
      <div class="verified-logo">
        <div class="verified-logo__icon">
          <i class="fa-regular fa-shield-check"></i>
        </div>
        <div class="verified-logo__title"
          [innerHTML]="header | safeHtml: SanitizerValueType.HTML"
        ></div>
        <div class="verified-logo__logo">
          <img src="https://assets.flynorse.com/static/site/norse-name-blue.svg" alt="Norse" />
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="verified-description">
        @switch ($comp.culture) {
          @case ('en-US' || 'en-GB') {
            The Verified by Norse Seal guarantees customers are booking on the legitimate Norse website and includes:
          }
          @case ('nb-NO') {
            Verifisert av Norse-seglet garanterer at kundene bestiller på den legitime Norse-nettsiden og inkluderer:
          }
          @case ('de-DE') {
            Das Verifiziert von Norse-Siegel garantiert den Kunden, dass sie auf der legitimen Norse-Website buchen, und umfasst:
          }
          @case ('fr-FR') {
            Le sceau Vérifié par Norse garantit aux clients qu'ils réservent sur le site officiel de Norse et inclut :
          }
          @case ('it-IT') {
            Il sigillo Verificato da Norse garantisce ai clienti che stanno prenotando sul sito ufficiale di Norse e include:
          }
          @case ('es-ES') {
            El sello Verificado por Norse garantiza a los clientes que están reservando en el sitio web legítimo de Norse e incluye:
          }
          @default {
            The Verified by Norse Seal guarantees customers are booking on the legitimate Norse website and includes:
          }
        }
      </div>
      <div class="verified-items">
        <div class="verified-item"
          [innerHTML]="
          verifiedTitleOne | safeHtml: SanitizerValueType.HTML
        "></div>
        <div class="verified-item"
          [innerHTML]="
          verifiedTitleTwo | safeHtml: SanitizerValueType.HTML
        "></div>
        <div class="verified-item"
          [innerHTML]="
          verifiedTitleThree | safeHtml: SanitizerValueType.HTML
        "></div>
      </div>
      <div class="verified-explanation">
        <span>*</span>
        <span>
          @switch ($comp.culture) {
            @case ('en-US' || 'en-GB') {
              Cancel your flight within 24 hours of booking at no charge, as long as your flight is more than 7 days away.
            }
            @case ('nb-NO') {
              Avbestill flyreisen din innen 24 timer etter bestilling uten kostnad, så lenge flyreisen din er mer enn 7 dager unna.
            }
            @case ('de-DE') {
              Stornieren Sie Ihren Flug innerhalb von 24 Stunden nach der Buchung kostenlos, solange Ihr Flug mehr als 7 Tage entfernt ist.
            }
            @case ('fr-FR') {
              Annulez votre vol dans les 24 heures suivant la réservation sans frais, tant que votre vol est à plus de 7 jours.
            }
            @case ('it-IT') {
              Annulla il tuo volo entro 24 ore dalla prenotazione senza alcun costo, a condizione che il volo sia a più di 7 giorni di distanza.
            }
            @case ('es-ES') {
              Cancele su vuelo dentro de las 24 horas posteriores a la reserva sin cargo, siempre que su vuelo esté a más de 7 días de distancia.
            }
            @default {
              Cancel your flight within 24 hours of booking at no charge, as long as your flight is more than 7 days away.
            }
          }
        </span>
      </div>
    </div>
    <div class="modal-footer verified-footer">
      <button class="btn verified-btn" (click)="onCloseClick()">
        {{ verifiedAcknowledgement }}
      </button>
    </div>
  }
</ng-container>
